module.exports = __webpack_public_path__ + "img/des_paint_1.94ae1c02.jpg";